/**
 * VEX-6439 · el inicio del checkout, que es de donde sale `begin_checkout`.
 *
 * Hasta ahora `begin_checkout` lo emitía Plan.vue en el clic de suscribirse,
 * pero las landings de planes las sirve Framer, que no monta Plan.vue: sus
 * botones llevan directo a /purchase/:id. Salían 4 begin_checkout en 28 días
 * contra 71 purchase. El checkout arranca en PurchaseFlow, en los mismos dos
 * puntos donde ya se emitía `purchase_flow_start`.
 */
import { beginCheckoutPayload } from '@/utils/analytics/ecommerce';

const PLANS = 'plans';

/**
 * ¿Este cambio de estado de PurchaseFlow es el inicio del checkout?
 *
 * - Al montar, en cualquier estado que no sea la lista de planes: es /purchase
 *   o /purchase/:id.
 * - En el modal (`showPlans`), al salir de la lista de planes.
 *
 * Cualquier otro cambio (login → pago, pago → descarga) es el mismo checkout
 * avanzando, y contarlo de nuevo duplicaría el begin_checkout. El montaje va
 * con un flag explícito y no se deduce de `previousStatus`: created() pasa por
 * changeStatus antes de montar con lo que haya en el store, y eso no puede
 * contar como inicio.
 *
 * @param {{ mounting?: boolean, previousStatus?: string, status: string, showPlans?: boolean }} t
 */
export const startsCheckout = ({ mounting = false, previousStatus, status, showPlans = false }) => {
  if (mounting) return status !== PLANS;
  return showPlans && previousStatus === PLANS && status !== PLANS;
};

/**
 * Lo que se empuja al dataLayer cuando arranca el checkout, como argumentos de
 * `$dataLayerPush`. Sin plan abierto no hay begin_checkout: un evento de
 * comercio sin items no sirve en el embudo.
 *
 * @param {{ plan?: object|null, loggedIn: boolean }} contexto
 * @returns {Array<Array>} cada elemento es `[evento, data, ecommerce?]`
 */
export const checkoutStartPushes = ({ plan, loggedIn }) => {
  const pushes = [
    ['purchase_flow_start', { startStatus: loggedIn ? 'logged_in' : 'not_logged_in' }]
  ];
  if (plan) {
    const { data, ecommerce } = beginCheckoutPayload(plan);
    pushes.push(['begin_checkout', data, ecommerce]);
  }
  return pushes;
};
